import { LookConfig } from '@nucleus/types/web';
import { createContext } from 'react';

export type LookConfigContext = LookConfig;
export const LookConfigContext = createContext<LookConfigContext>({} as LookConfigContext);
LookConfigContext.displayName = 'LookConfigContext';
